import { COLOR_HEX, COLOR_LABELS, PlayerState, RingSize, SIZES } from '@otrio/engine';

interface MiniTrayProps {
  player: PlayerState;
}

const RING_R: Record<RingSize, number> = { small: 5, medium: 8, large: 11 };
const RING_SW: Record<RingSize, number> = { small: 3, medium: 4, large: 5 };
const VIEW = 28;

export function MiniTray({ player }: MiniTrayProps) {
  const hex = COLOR_HEX[player.color];
  const total = SIZES.reduce((s, sz) => s + player.pieces[sz], 0);

  return (
    <div className="mini-tray" title={`${player.name} (${COLOR_LABELS[player.color]})`} style={{ '--mini-color': hex } as React.CSSProperties}>
      <div className="mini-tray-label">
        <span className="mini-dot" style={{ background: hex }} />
        <span className="mini-name" style={{ color: hex }}>{player.name}</span>
      </div>
      <div className="mini-rings">
        {SIZES.map(size => {
          const count = player.pieces[size];
          return (
            <div key={size} className="mini-ring-slot">
              <svg width={VIEW} height={VIEW} viewBox={`0 0 ${VIEW} ${VIEW}`}>
                <circle
                  cx={VIEW / 2} cy={VIEW / 2}
                  r={RING_R[size]}
                  fill="none"
                  stroke={count > 0 ? hex : '#2d3f52'}
                  strokeWidth={RING_SW[size]}
                  opacity={count > 0 ? 0.9 : 0.25}
                />
              </svg>
              <span className="mini-count" style={{ color: count > 0 ? hex : '#3a4f66' }}>{count}</span>
            </div>
          );
        })}
      </div>
      {total === 0 && <span className="mini-out">out</span>}
    </div>
  );
}
